export var validateCardCcv=function validateCardCcv(ccv){if(!ccv)return false;var regex=/^\d{3,4}$/;return regex.test(ccv);};